import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { makeStyles } from '@material-ui/core/styles';
import axios from 'axios';
import Header from './Header';
import { DropzoneArea } from 'material-ui-dropzone';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import UploadCompleteModal from './UploadCompleteModal';
import Instructions from './Instructions';
import Progress from './Progress';
import { API } from '../config';
// import { crc32 } from 'crc';
import qs from 'query-string';

import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import { Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    width: 500,
    height: 450,
  },
}));

export default function ImageView({ location }) {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [images, setImages] = useState([]);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');

  useEffect(() => {
    const photographer_id = getURLParams('photographer_id');
    const submission_id = getURLParams('submission_id');
    const talent_submission_id = getURLParams('talent_submission_id');

    if (!(photographer_id || submission_id || talent_submission_id)) {
      let str = '';

      if (photographer_id == null) {
        const email_address = getURLParams('email_address');
        enqueueSnackbar('Invalid URL, Redirecting ', { variant: 'warning' });

        const reqData = {
          email_address,
        };
        axios
          .post(`${API}/get_hiring_id`, reqData)
          .then((d) => {
            if (d.data.success === true) {
              let url = window.location.href;
              console.log('ID found: ', url);
              const query = qs.parse(location.search, {
                ignoreQueryPrefix: true,
              });
              let account_id = d.data.account.Id;
              query.submission_id = account_id.slice(0, -3);
              console.log(qs.stringify(query));
              window.location = `/view?${qs.stringify(query)}`;
            } else {
              console.log('inside else: ', d.data.success);
              str = 'Submission';
            }
          })
          .catch((err) => {
            console.log('[I] upload mark failure. ');
          });
      } else {
        str = 'Photographer';
      }
      if (str.length > 0) {
        enqueueSnackbar('Invalid URL, Please provide valid ' + str + ' ID', { variant: 'error' });
      }
      return false;
    } else {
      axios
        .post(`${API}/getReadSignedUrl`, {
          photographer_id: getURLParams('photographer_id'),
          submission_id: getURLParams('submission_id'),
          talent_submission_id: getURLParams('talent_submission_id'),
          // first_name: getURLParams('first_name'),
          // last_name: getURLParams('last_name'),
          application_date: getURLParams('application_date'),
          Email: getURLParams('email_address'),
          // Filename: file.name,
          // ContentType: file.type,
          Action: 'READ',
        })
        .then((res) => {
          if (res.data.success == true) {
            // setFirstName(getURLParams('first_name'));
            // setLastName(getURLParams('last_name'));
            setFirstName(res.data.first_name);
            setLastName(res.data.last_name);
            setImages(res.data.images);
          } else {
            enqueueSnackbar('Data not found.', { variant: 'error' });
          }
        })
        .catch((signingErr) => {
          console.log('[E] Error getting signed url', signingErr);
          enqueueSnackbar('Images loading error.', { variant: 'error' });
        });
    }
  }, []);

  const getURLParams = (param) => {
    let parsedURL = decodeURI(location.search);
    const urlParams = new URLSearchParams(parsedURL);
    const parsedParam = urlParams.get(param);
    console.log('parsed param: ', parsedParam);
    return parsedParam;
  };

  return (
    <div>
      <Header />
      {images.length > 0 && (
        <div style={{ margin: '20px' }}>
          <Typography variant="h6" className={classes.title}>
            Member Name: {firstName} {lastName}
          </Typography>
          <GridList cellHeight={300} className={classes.gridList} cols={5}>
            {images.map((tile) => (
              <GridListTile key={tile.name} cols={1}>
                <div className="img-outer">
                  <img src={tile.url} alt={tile.name} />
                </div>
                <p style={{ color: 'black' }}>
                  Size: {tile.size} Type: {tile.type}
                </p>
              </GridListTile>
            ))}
          </GridList>
        </div>
      )}
    </div>
  );
}
